import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UploadImage from './UploadImage';
import { displayImageStyle } from '../../css/style';

const styles = displayImageStyle();

export default class DisplayImages extends Component {
  static propTypes = {
    data: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    allowMultiple: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);
    // Set undefined and null to be the same check
    const images = ((props.data === undefined || props.data === null) && props.allowMultiple) ? [] : (props.data === undefined) ? null : props.data;
    this.state = { images };
  }

  componentDidUpdate = (prevProps) => {
    const { data, allowMultiple } = this.props;
    if (prevProps.data !== data) {
      const newImages = ((data === undefined || data === null) && allowMultiple) ? [] : (data === undefined) ? null : data;
      this.setState({ images: newImages });
    }
  }

  onChangeImage = (base64Url, position) => {
    let { images } = this.state;
    const { resourceName } = this.props;
    if (position !== undefined) {
      if (base64Url === null) {
        images.splice(position, 1);
      } else if (position > images.length) {
        resourceName === 'companies' ? images.push(base64Url) : images.push({ src: base64Url });
      } else {
        images[position] = resourceName === 'companies' ? base64Url : { src: base64Url };
      }
    } else {
      images = base64Url;
    }
    this.props.onChange(images);
  }

  onDeleteImage = (base64Url, position) => {
    const { resourceName } = this.props;
    let newImageArray = [];
    if (resourceName === 'companies') {
      const imagesCopy = this.state.images.slice();
      newImageArray = imagesCopy.filter(image => image !== base64Url);
    }
    this.props.onChange(newImageArray);
  }

  renderMultipleImage = (images) => {
    const { type, resourceName } = this.props;
    return (
      <div style={styles.multipleImageContainer}>
        {images.map((image, index) => (
          <UploadImage
            key={index}
            onChangeInput={() => { }}
            onDeleteImage={(position) => { this.onDeleteImage(position); }}
            image={resourceName === 'companies' ? image : image.src}
            index={index}
            type={type}
          />
        ))}
        <UploadImage
          onChangeInput={(base64Url) => { this.onChangeImage(base64Url, images.length); }}
          image={null}
          allowMultiple
          type={type}
        />
      </div>
    );
  }


  render() {
    const { images } = this.state;
    const { allowMultiple, type, disabled } = this.props;
    return (
      (allowMultiple)
        ? this.renderMultipleImage(images)
        : (
          <UploadImage
            disabled={disabled}
            onChangeInput={(base64Url) => { this.onChangeImage(base64Url); }}
            onDeleteImage={(position) => { this.onDeleteImage(position); }}
            image={(images && images[0] && images[0].src === undefined) ? images : images && images[0] && images[0].src}
            type={type}
          />
        )
    );
  }
}
